module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Bold.50475e93.ttf";